<section class="not-login flex h-screen items-center justify-center">
  <div class="ic-message">
    <img class="ic-logo" src="../../../../assets/img/i-c-logo-black.png" alt="Logo de I-Caranty" />
    <span>Bienvenido inicia sesión para continuar... </span>
    <button class="ic-btn-primary" (click)="loginRedirect()">
      <span>Iniciar sesión</span>
    </button>
  </div>
</section>
